import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { PlIcon } from '@app/icon-library/icons';
import { HttpQueryInterface, HttpRequestType, HttpService } from '@shared/http/http.service';

export interface FriendSurveyStatus {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  token: string;
  submitted: 1 | 0;
  sent: number;
  created_at: string;
  updated_at: string;
  feedback_length: number;
  nb_questions_answered: number;
}

@Component({
  selector: 'pl-profile-friends-survey-status-tab',
  templateUrl: './friendsSurveyStatus.component.html',
})
export class FriendsSurveyStatusComponent implements OnInit {
  public isLoading: WritableSignal<boolean> = signal(true);
  public friendsSurveyStatus: WritableSignal<FriendSurveyStatus[]> = signal([]);

  public readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
  public readonly PlIcon: typeof PlIcon = PlIcon;

  constructor(private httpService: HttpService) {}

  public ngOnInit(): void {
    console.log('\x1b[41m TONIO FriendsSurveyStatusComponent ngOnInit =', '\x1b');
    this.retrieveFriendsSurveyStatus();
  }

  public retrieveFriendsSurveyStatus(): void {
    const requestOptions: HttpQueryInterface = {
      type: HttpRequestType.GET,
      url: `/friendsSurveyStatus`,
    };

    this.httpService.request(requestOptions).subscribe({
      next: (friendsSurveyStatus: FriendSurveyStatus[]) => {
        console.log('TONIO FriendsSurveyStatusComponent next friendsSurveyStatus=', friendsSurveyStatus);
        this.friendsSurveyStatus.set(friendsSurveyStatus);
        this.isLoading.set(false);
      },
    });
  }
}
